import { render, staticRenderFns } from "./CompanyShopTargetsSetting.vue?vue&type=template&id=f3c97b02&scoped=true"
import script from "./CompanyShopTargetsSetting.vue?vue&type=script&lang=js"
export * from "./CompanyShopTargetsSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyShopTargetsSetting.vue?vue&type=style&index=0&id=f3c97b02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c97b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c97b02')) {
      api.createRecord('f3c97b02', component.options)
    } else {
      api.reload('f3c97b02', component.options)
    }
    module.hot.accept("./CompanyShopTargetsSetting.vue?vue&type=template&id=f3c97b02&scoped=true", function () {
      api.rerender('f3c97b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyShopTargetsSetting.vue"
export default component.exports